import axiosInstance from "auth/FetchInterceptor";
import { ACCESS_HISTORY_SEARCH } from "constants/ApiConstant";

const AccessHistoryService = {};

AccessHistoryService.search = function (params) {
  return axiosInstance.post(ACCESS_HISTORY_SEARCH, params);
};

export default AccessHistoryService;
